<sz-bottom-sheet [open]="open()" (close)="onClose()">
  <div szSheetHeader class="fab-qs__head">
    <div class="fab-qs__head-text">
      <span class="fab-qs__kicker">
        <span class="fab-qs__dot" aria-hidden="true"></span>
        {{ 'fabQuickStart.kicker' | translate }}
      </span>
      <h3 class="fab-qs__title">{{ titleKey() | translate }}</h3>
    </div>
    <sz-icon-button icon="x" size="sm" [ariaLabel]="'common.close' | translate" (click)="onClose()" />
  </div>

  @if (loading()) {
    <p class="fab-qs__loading">{{ 'common.loading' | translate }}</p>
  }
  @if (viewModel(); as vm) {
    @switch (vm.variant) {
      @case ('plan') {
        @if (vm.todayPlan; as plan) {
          <section class="fab-qs__section">
            <span class="fab-qs__label">{{ 'fabQuickStart.today' | translate }}</span>
            <sz-action-row
              kind="primary"
              icon="play"
              [title]="'fabQuickStart.startTodayPlan' | translate"
              [sub]="plan.subLabel"
              (action)="startTodayPlan()" />
          </section>
        }
        <section class="fab-qs__section">
          <span class="fab-qs__label">{{ 'fabQuickStart.adhoc' | translate }}</span>
          <sz-action-row
            kind="secondary"
            icon="target"
            [title]="'fabQuickStart.startFromDrills' | translate"
            [sub]="vm.drillsSubLabel"
            (action)="startFromDrills()" />
          @if (vm.lastDrill; as last) {
            <sz-action-row
              kind="secondary"
              icon="refresh"
              [title]="'fabQuickStart.repeatLastDrill' | translate"
              [sub]="last.subLabel"
              (action)="repeatLastDrill()" />
          }
        </section>
        <section class="fab-qs__section">
          <span class="fab-qs__label">{{ 'fabQuickStart.plan' | translate }}</span>
          <sz-action-row
            kind="tertiary"
            icon="plus"
            [title]="'fabQuickStart.createPlan' | translate"
            [sub]="'fabQuickStart.createPlanSub' | translate"
            (action)="createPlan()" />
        </section>
      }
      @case ('drills') {
        <section class="fab-qs__section">
          <span class="fab-qs__label">{{ 'fabQuickStart.trainNow' | translate }}</span>
          <sz-action-row
            kind="primary"
            icon="target"
            [title]="'fabQuickStart.startFromDrills' | translate"
            [sub]="vm.drillsSubLabel"
            (action)="startFromDrills()" />
          @if (vm.lastDrill; as last) {
            <sz-action-row
              kind="secondary"
              icon="refresh"
              [title]="'fabQuickStart.repeatLastDrill' | translate"
              [sub]="last.subLabel"
              (action)="repeatLastDrill()" />
          }
        </section>
        <section class="fab-qs__section">
          <span class="fab-qs__label">{{ 'fabQuickStart.plan' | translate }}</span>
          <sz-action-row
            kind="tertiary"
            icon="plus"
            [title]="'fabQuickStart.createPlan' | translate"
            [sub]="'fabQuickStart.createPlanSub' | translate"
            (action)="createPlan()" />
        </section>
        <p class="fab-qs__footer">{{ 'fabQuickStart.noPlanFooter' | translate }}</p>
      }
      @case ('empty') {
        <p class="fab-qs__empty-desc">{{ 'fabQuickStart.emptyDescription' | translate }}</p>
        <section class="fab-qs__section">
          <sz-action-row
            kind="primary"
            icon="plus"
            [title]="'fabQuickStart.createDrill' | translate"
            [sub]="'fabQuickStart.createDrillSub' | translate"
            (action)="createDrill()" />
        </section>
        <section class="fab-qs__section">
          <span class="fab-qs__label">{{ 'fabQuickStart.disabledUntilDrill' | translate }}</span>
          <sz-action-row
            kind="tertiary"
            icon="target"
            [title]="'fabQuickStart.startFromDrills' | translate"
            [sub]="'fabQuickStart.needsDrill' | translate"
            [soon]="true"
            [disabled]="true" />
          <sz-action-row
            kind="tertiary"
            icon="calendar"
            [title]="'fabQuickStart.createPlan' | translate"
            [sub]="'fabQuickStart.needsDrill' | translate"
            [soon]="true"
            [disabled]="true" />
        </section>
      }
    }
  }
</sz-bottom-sheet>
